import { Label, Slider } from '@creanizer/ui'
import type { WorldBuilderInput } from '@creanizer/types'

interface WorldParametersFormProps {
  input: WorldBuilderInput
  onChange: (input: WorldBuilderInput) => void
}

const PARAMETERS = [
  { key: 'magicLevel', label: '魔法レベル', description: '魔法の存在度（1:なし〜10:支配的）' },
  { key: 'scienceLevel', label: '科学技術レベル', description: '科学技術の発達度（1:原始〜10:超未来）' },
  { key: 'civilizationLevel', label: '文明レベル', description: '社会の発達度（1:原始〜10:高度文明）' },
  { key: 'dangerLevel', label: '危険度', description: '世界の危険さ（1:安全〜10:極めて危険）' },
  { key: 'mysteryLevel', label: '神秘性', description: '未知や謎の多さ（1:明瞭〜10:神秘的）' },
  { key: 'complexityLevel', label: '複雑さ', description: '世界の複雑さ（1:単純〜10:非常に複雑）' },
  { key: 'uniquenessLevel', label: '独自性', description: '独創的な要素の多さ（1:一般的〜10:非常に独特）' },
  { key: 'chaosLevel', label: '混沌度', description: '秩序と混沌のバランス（1:秩序的〜10:混沌）' },
]

export function WorldParametersForm({ input, onChange }: WorldParametersFormProps) {
  const handleParameterChange = (key: string, value: number) => {
    onChange({
      ...input,
      parameters: {
        ...input.parameters!,
        [key]: value,
      },
    })
  }
  
  const parameters = input.parameters || {
    magicLevel: 5,
    scienceLevel: 5,
    civilizationLevel: 5,
    dangerLevel: 5,
    mysteryLevel: 5,
    complexityLevel: 5,
    uniquenessLevel: 5,
    chaosLevel: 5,
  }
  
  return (
    <div className="space-y-4">
      <h4 className="font-semibold">世界観パラメータ</h4>
      
      <div className="grid gap-4">
        {PARAMETERS.map(({ key, label, description }) => (
          <div key={key} className="space-y-2">
            <div className="flex justify-between items-center">
              <Label>{label}</Label>
              <span className="text-sm font-medium">{parameters[key as keyof typeof parameters]}/10</span>
            </div>
            <Slider
              value={[parameters[key as keyof typeof parameters] || 5]}
              onValueChange={([value]) => handleParameterChange(key, value)}
              min={1}
              max={10}
              step={1}
              className="w-full"
            />
            <p className="text-xs text-muted-foreground">{description}</p>
          </div>
        ))}
      </div>
    </div>
  )
}